import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { hotelPath } from 'app/hooks/data/hotels/useHotel';
import type {
  ExtranetHotelContacts,
  ExtranetHotelContactsPatch,
} from 'app/typings/core/extranet/hotel/contacts';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useUpdateHotelContacts(hotelId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ExtranetHotelContactsPatch) =>
      apiMutation(
        'PATCH',
        {
          path: ENDPOINTS.updateHotelContacts,
          params: { id: hotelId?.toString() },
        },
        payload
      ) as Promise<ExtranetHotelContacts>,
    onSuccess: () => {
      message.success('Hotel Contacts successfully changed');

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.hotelContacts],
      });

      queryClient.invalidateQueries({
        queryKey: [hotelPath, { hotelId }],
      });
    },
    onError: () => {
      message.error('Failed to change Hotel Contacts.');
    },
  });
}
